var map = {
	"./template.bet575": 1581,
	"./template.bet575.tsx": 1581,
	"./template.bet777": 1582,
	"./template.bet777.tsx": 1582,
	"./template.betgalaxy": 1583,
	"./template.betgalaxy.tsx": 1583,
	"./template.betprofessor": 1584,
	"./template.betprofessor.tsx": 1584,
	"./template.betroyale": 1585,
	"./template.betroyale.tsx": 1585,
	"./template.betstride": 1586,
	"./template.betstride.tsx": 1586,
	"./template.buffalobet": 1587,
	"./template.buffalobet.tsx": 1587,
	"./template.chromabet": 1588,
	"./template.chromabet.tsx": 1588,
	"./template.default": 91,
	"./template.default.tsx": 91,
	"./template.epicodds": 1589,
	"./template.epicodds.tsx": 1589,
	"./template.fiestabet": 1590,
	"./template.fiestabet.tsx": 1590,
	"./template.forsport": 1591,
	"./template.forsport.tsx": 1591,
	"./template.gigabet": 1592,
	"./template.gigabet.tsx": 1592,
	"./template.goldenbet888": 1593,
	"./template.goldenbet888.tsx": 1593,
	"./template.goldenrush": 1594,
	"./template.goldenrush.tsx": 1594,
	"./template.hyperbet": 1595,
	"./template.hyperbet.tsx": 1595,
	"./template.juicybet": 1596,
	"./template.juicybet.tsx": 1596,
	"./template.junglebet": 1597,
	"./template.junglebet.tsx": 1597,
	"./template.magnumbet": 1598,
	"./template.magnumbet.tsx": 1598,
	"./template.oldgill": 1599,
	"./template.oldgill.tsx": 1599,
	"./template.puntcity": 1600,
	"./template.puntcity.tsx": 1600,
	"./template.puntgenie": 1601,
	"./template.puntgenie.tsx": 1601,
	"./template.pyramidbet": 1602,
	"./template.pyramidbet.tsx": 1602,
	"./template.questbet": 1603,
	"./template.questbet.tsx": 1603,
	"./template.slambet": 1604,
	"./template.slambet.tsx": 1604,
	"./template.sterlingparker": 1605,
	"./template.sterlingparker.tsx": 1605,
	"./template.sugarcastle": 1606,
	"./template.sugarcastle.tsx": 1606,
	"./template.templebet": 1607,
	"./template.templebet.tsx": 1607,
	"./template.titanbet": 1608,
	"./template.titanbet.tsx": 1608,
	"./template.ts": 983,
	"./template.vikingbet": 1609,
	"./template.vikingbet.tsx": 1609,
	"./template.volcanobet": 1610,
	"./template.volcanobet.tsx": 1610,
	"./template.wellbet": 1611,
	"./template.wellbet.tsx": 1611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2452;